import { DataSecurityInformationComponent } from "../pages/data-security-information/DataSecurityInformationComponent";
import { DataSecurityComponent } from "../pages/data-security/DataSecurity";
import { HomeComponent } from "../pages/home/HomeComponent";
import { InformationPolicyComponent } from "../pages/information-policy/InformationPolicyComponent";
import { NotFoundComponent } from "../pages/not-fount/NotFoundComponent";
import { PasswordRecoveryComponent } from "../pages/password-recovery/PasswordRecoveryComponent";
import { PoliciesComponent } from "../pages/policies/PoliciesComponent";

export const Routes = [
  {
    path: "/",
    component: <HomeComponent />,
    exact: true,
    protected: false,
  },
  {
    path: "/policies",
    component: <PoliciesComponent />,
    exact: true,
    protected: false,
  },
  {
    path: "/policies/:appCode",
    component: <InformationPolicyComponent />,
    exact: true,
    protected: false,
  },
  {
    path: "/data-security",
    component: <DataSecurityComponent />,
    exact: true,
    protected: false,
  },
  {
    path: "/data-security/:appCode",
    component: <DataSecurityInformationComponent />,
    exact: true,
    protected: false,
  },
  {
    path: "/password-recovery",
    component: <PasswordRecoveryComponent />,
    exact: true,
    protected: false,
  },
  {
    path: "*",
    component: <NotFoundComponent />,
    exact: false,
    protected: false,
  },
];
